import actions from './actions.js'
import { state, mutations } from './mutations.js'
import getters from './getters.js'

const debug = process.env.NODE_ENV !== 'production'

export default {
  state,
  getters,
  actions,
  mutations,
  strict: debug
}



// WEBPACK FOOTER //
// ./src/store/cart/index.js